/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock': {
    width: 16,
    height: 21,
    viewBox: '0 0 16 21',
    data: '<defs/><path pid="0" class="a" d="M14 7a2.051 2.051 0 0 1 2 2v10a2.051 2.051 0 0 1-2 2H2a2.051 2.051 0 0 1-2-2V9a2.051 2.051 0 0 1 2-2h1V5a4.539 4.539 0 0 1 1.5-3.5A5.288 5.288 0 0 1 8 0a4.691 4.691 0 0 1 3.5 1.5A5.288 5.288 0 0 1 13 5v2zm-2.9 0V5a3.1 3.1 0 0 0-.9-2.2A3.1 3.1 0 0 0 4.9 5v2zm-4.5 8.4A1.933 1.933 0 1 0 6 14a1.974 1.974 0 0 0 .6 1.4z"/>'
  }
})
